<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "donationCategory",
  data() {
    return {};
  },
  created() {}
};
</script>
